export const SET_IS_PENDING = 'rpb2b-react/orders/SET_IS_PENDING';
export type SET_IS_PENDING = typeof SET_IS_PENDING;

export const SET_PAGE_NUMBER = 'rpb2b-react/orders/SET_PAGE_NUMBER';
export type SET_PAGE_NUMBER = typeof SET_PAGE_NUMBER;

export const SET_PAGE_SIZE = 'rpb2b-react/orders/SET_PAGE_SIZE';
export type SET_PAGE_SIZE = typeof SET_PAGE_SIZE;

export const SET_TOTAL_ELEMENTS = 'rpb2b-react/orders/SET_TOTAL_ELEMENTS';
export type SET_TOTAL_ELEMENTS = typeof SET_TOTAL_ELEMENTS;

export const SET_TOTAL_PAGES = 'rpb2b-react/orders/SET_TOTAL_PAGES';
export type SET_TOTAL_PAGES = typeof SET_TOTAL_PAGES;

export const SET_ORDER = 'rpb2b-react/orders/SET_ORDER';
export type SET_ORDER = typeof SET_ORDER;

export const SET_RECENT_ORDERS = 'rpb2b-react/orders/SET_RECENT_ORDERS';
export type SET_RECENT_ORDERS = typeof SET_RECENT_ORDERS;

export const CLEAR_ALL = 'rpb2b-react/orders/CLEAR_ALL';
export type CLEAR_ALL = typeof CLEAR_ALL;

export const SET_ERROR = 'rpb2b-react/orders/SET_ERROR';
export type SET_ERROR = typeof SET_ERROR;

export const SET_TRACKING_NUMBER = 'rpb2b-react/orders/SET_TRACKING_NUMBER';
export type SET_TRACKING_NUMBER = typeof SET_TRACKING_NUMBER;

export default {
  SET_IS_PENDING,
  SET_PAGE_NUMBER,
  SET_PAGE_SIZE,
  SET_TOTAL_ELEMENTS,
  SET_TOTAL_PAGES,
  SET_ORDER,
  SET_RECENT_ORDERS,
  CLEAR_ALL,
  SET_ERROR,
  SET_TRACKING_NUMBER
};
